import { DatePart, StringUtil } from "@mcleod/core";
import { LayoutProvidedReportDecoratorProps, LookupModelSearchEvent, Snackbar } from "@mcleod/components";
import {
    AutogenLayoutCustomersBelowMonthlyOrderGoalReport
} from "./autogen/AutogenLayoutCustomersBelowMonthlyOrderGoalReport";

export class CustomersBelowMonthlyOrderGoalReport extends AutogenLayoutCustomersBelowMonthlyOrderGoalReport {
    override onLoad(): void | Promise<void> {
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
        this.setIntervalMaxValue();
        this.setMinMaxTooltip();
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.textboxDisplayInterval.text = "1";
        this.textboxGoalNum.displayLabel = "Orders Below Monthly Goal";
    }

    excludabletextboxCTextboxBeforeLookupModelSearch(event:  LookupModelSearchEvent) {
        event.filter.customer = "Y"
    }

    switchPercentOrNumberOnChange(){
        this.textboxGoalNum.text = "";
        if(this.switchPercentOrNumber.checked){
            this.textboxGoalNum.displayLabel = "Orders Below Monthly Goal";
        }
        else{
            this.textboxGoalNum.displayLabel = "Percentage Of Monthly Goal";
        }
    }

    private setIntervalMaxValue() {
        const range = this.textboxDateRange.getDateRange();
        this.textboxDisplayInterval.maxValue = range.getDifferenceInDates(DatePart.DAY);
        this.textboxDisplayInterval.validateSimple(true, true);
        this.setMinMaxTooltip();
    }

    private setMinMaxTooltip() {
        this.textboxDisplayInterval.tooltip =
            `Please enter a number between ${this.textboxDisplayInterval.minValue} and ${this.textboxDisplayInterval.maxValue}.`;
    }

    textboxDisplayIntervalOnBlur(){
        if(StringUtil.isEmptyString(this.textboxDisplayInterval.text)){
            Snackbar.showWarningSnackbar("Display Interval (In Days) cannot be empty");
            this.textboxDisplayInterval.text = "1";
        }
    }

    textboxGroupByOnChange() {
        const groupBy = this.textboxGroupBy.selectedItem?.displayValue;
        if(StringUtil.isEmptyString(groupBy)){
            return
        }
        this.checkboxpageBreak.checked = false;
        this.checkboxpageBreak.enabled = StringUtil.equalsIgnoreCase("none", groupBy) ? false : true;
    }

    /** This is an event handler for the onBlur event of textboxDateRange. */
    textboxDateRangeOnBlur() {
        this.setIntervalMaxValue();
    }

    public get reportDecoratorProps(): Partial<LayoutProvidedReportDecoratorProps> {
        return {
            doOnResetForm: () => this.setIntervalMaxValue()
        };
    }
}
